import { CloseCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import '@/assets/style/companyList.scss';

const CancelModalButton = ({ showCancelModal, data }) => {
  return (
    <div className="ant-button-delete">
      <Link size="medium" onClick={() => showCancelModal(data)}>
        <CloseCircleOutlined className="tw-text-white tw-bg-yellow-500 tw-text-xl tw-rounded-full hover:tw-bg-yellow-300 hover:tw-cursor-pointer" />
      </Link>
    </div>
  );
};

export default CancelModalButton;
